import type { NuveiCardDetails } from '@/utils/nuvei';

export enum GetTokenStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface GetTokenResponse {
  cardType: string;
  ccTempToken: string;
  errCode: number;
  internalRequestId: string;
  isVerified: boolean;
  issuerCountry: string;
  reason: string;
  sessionToken: string;
  status: GetTokenStatus;
  uniqueCC: string;
  version: string;
}

export interface NuveiField {
  name: string;
  displayName: string;
}

export interface SafeChargeInstance {
  fields: (config: {
    fonts: Array<{ cssUrl: string }>;
    locale: string;
    fontSize?: string;
    i18n?: Record<string, string>;
  }) => SafeChargeFields;
  createPayment: (params: unknown, callback: (response: unknown) => void) => void;
  authenticate3d: (params: unknown, callback: (response: unknown) => void) => void;
  getToken: (field: unknown, params: unknown) => Promise<GetTokenResponse>;
  cardObj: unknown;
  getCardDetails: (params: unknown, callback: (response: unknown) => void) => Promise<unknown>;
}

export interface NuveiFieldStyle {
  [key: string]: string | { [key: string]: string | { [key: string]: string } };
}

export interface SafeChargeFields {
  create: (fieldType: 'ccNumber' | 'ccExpiration' | 'ccCvc', config?: { style?: NuveiFieldStyle }) => SafeChargeField;
  authenticate3d: (params: unknown, callback: unknown) => Promise<unknown>;
  getToken: (params: unknown) => Promise<unknown>;
  cardObj: unknown;
  safeChargeInstance: SafeChargeInstance | null;
  cardDetails?: NuveiCardDetails;
  sessionToken?: string;
}

export interface SafeChargeField {
  cardObj: unknown;
  attach: (selector: string) => void;
  on: (event: string, callback: (data: unknown) => void) => void;
  focus?: () => void;
}

declare global {
  interface Window {
    SafeCharge: (config: { merchantId: string; merchantSiteId: string; env: string }) => SafeChargeInstance;
  }
}

export enum Nuvei3DSErrorDescription {
  CARD_DOES_NOT_SUPPORT_3D_SECURE = 'Card does not support 3D secure',
}
export interface Nuvei3DSResponse {
  result: 'ERROR' | 'SUCCESS';
  errorDescription: Nuvei3DSErrorDescription;
  ccTempToken: string;
  transactionId: string;
}
